import React from 'react';
import { Link } from 'react-router-dom';
import Card from 'components/Card';
import { parseCropHash, getFramedImageStyles } from 'utils/cropUtils';
import { stripHtml } from 'utils/string';
import { Anchor, DateText, Description, Divider, ImageContent, InfoContent, News, Title, Info } from './styles';

interface IProps {
  image: string;
  date: string;
  title: string;
  description: string;
  link: string;
}

const NewsCard = (props: IProps): JSX.Element => {
  const { image, date, title, description, link } = props;
  const { cleanUrl, crop } = parseCropHash(image);
  const { containerStyle, imageStyle } = getFramedImageStyles(crop);

  return (
    <Card>
      <News className="news">
        <ImageContent className="news-image" style={{ position: 'relative', overflow: 'hidden', flexShrink: 0 }}>
          <div
            style={{
              position: 'absolute',
              top: '-10%',
              left: '-10%',
              width: '120%',
              height: '120%',
              background: `url(${cleanUrl}) center center / cover no-repeat`,
              filter: 'blur(15px)',
              zIndex: 1,
            }}
          />
          <div style={containerStyle}>
            <img src={cleanUrl} alt={title} style={imageStyle} />
          </div>
        </ImageContent>
        <InfoContent>
          <Info>
            <DateText>{date}</DateText>
            <Title className="news-title">{title}</Title>
            <Description>{stripHtml(description)}</Description>
          </Info>
          <Info>
            <Divider />
            <Link to={link}>
              <Anchor>Ler Mais</Anchor>
            </Link>
          </Info>
        </InfoContent>
      </News>
    </Card>
  );
};

export default NewsCard;
